export class LocalStorageinfo{
    selectedConfig: number;  
}